"use strict";

require("core-js/modules/es.string.split");

var curry = require("./curry.js");

module.exports = curry(function split(sep, str) {
  return (str || "").split(sep);
});